import script from "./CardPartidaGestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPartidaGestion.vue?vue&type=script&setup=true&lang=ts"

import "./CardPartidaGestion.vue?vue&type=style&index=0&id=76225786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76225786"]])

export default __exports__